export const modalVisible = state => state.isVisible;



/** WEBPACK FOOTER **
 ** ./src/store/modules/modal/getters.js
 **/